import React, { useState, useEffect, useRef } from 'react';

const DEEP_MOSS   = '#283618';
const TERRACOTTA  = '#BC6C25';

const Atmosphere = () => {
  const [isOpen,     setIsOpen]     = useState(false);
  const [isPlaying,  setIsPlaying]  = useState(false);
  const [playerKey,  setPlayerKey]  = useState(0);
  const [isMobile,   setIsMobile]   = useState(window.innerWidth < 768);
  const popupRef = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isOpen && popupRef.current && !popupRef.current.contains(e.target)) {
        handleMinimize();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const handleMinimize = () => setIsOpen(false);

  const handleClose = () => {
    setIsOpen(false);
    setIsPlaying(false);
    setPlayerKey(prev => prev + 1);
  };

  const bottom = isMobile ? '20px' : '40px';
  const right  = isMobile ? '20px' : '40px';

  return (
    <div style={{ ...fixedContainer, bottom, right }}>

      {/* ── Trigger ── */}
      <div style={{ display: isOpen ? 'none' : 'flex', alignItems: 'center', gap: '12px' }}>

        <div
          onClick={() => { setIsOpen(true); setIsPlaying(true); }}
          style={musicTrigger}
        >
          {isPlaying && (
            <div style={equalizerContainer}>
              <div style={barStyle} />
              <div style={{ ...barStyle, animationDelay: '0.2s' }} />
              <div style={{ ...barStyle, animationDelay: '0.4s' }} />
            </div>
          )}
          <span style={{ fontSize: '1.5rem', marginTop: isPlaying ? '-4px' : '0' }}>♪</span>
        </div>
      </div>

      {/* ── Popup card ── */}
      <div ref={popupRef} style={{ ...popupCard, display: isOpen ? 'flex' : 'none' }}>

        <div style={headerArea}>
          <h3 style={headerStyle}>
            <span style={{ color: TERRACOTTA, marginRight: '8px' }}>♪</span>
            Voci Iconiche
          </h3>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={handleMinimize} style={controlBtn} title="Minimizza">−</button>
            <button onClick={handleClose}    style={controlBtn} title="Spegni musica">✕</button>
          </div>
        </div>

        <p style={descriptionStyle}>
          Before you find <strong>your</strong> Italian voice, listen to the ones that inspired a generation.
        </p>

        <p style={headphonesNote}>🎧 Full songs require a free Spotify account</p>
        <div style={{ width: '100%' }}>
          <iframe
            key={playerKey}
            title="Spotify Playlist"
            style={{ borderRadius: '12px' }}
            src="https://open.spotify.com/embed/playlist/0JDRm5rGXLA3XagQjgjvpm?utm_source=generator"
            width="100%"
            height="152"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
          />
        </div>
      </div>

      <style>{`
        @keyframes soundBar {
          0%, 100% { height: 4px; }
          50%       { height: 12px; }
        }
      `}</style>
    </div>
  );
};

// ─── Styles ───────────────────────────────────────────────────────────────────
const fixedContainer = {
  position: 'fixed',
  zIndex: 9999,
};

const musicTrigger = {
  width: '56px',
  height: '56px',
  backgroundColor: DEEP_MOSS,
  color: '#fff',
  borderRadius: '50%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
  transition: 'all 0.3s ease',
  flexShrink: 0,
};

const equalizerContainer = {
  display: 'flex',
  alignItems: 'flex-end',
  gap: '2px',
  height: '14px',
  marginBottom: '2px',
};

const barStyle = {
  width: '3px',
  height: '4px',
  backgroundColor: TERRACOTTA,
  animation: 'soundBar 0.8s ease-in-out infinite',
};

const popupCard = {
  backgroundColor: '#F9F7F2',
  width: '300px',
  padding: '22px',
  borderRadius: '20px',
  boxShadow: '0 20px 60px rgba(0,0,0,0.14)',
  border: '1px solid #eee',
  flexDirection: 'column',
  gap: '12px',
};

const headerArea = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

const headerStyle = {
  fontFamily: "'Montserrat', sans-serif",
  fontSize: '0.8rem',
  color: DEEP_MOSS,
  letterSpacing: '1.5px',
  textTransform: 'uppercase',
  margin: 0,
  display: 'flex',
  alignItems: 'center',
};

const controlBtn = {
  background: '#EAE7E0',
  border: 'none',
  width: '26px',
  height: '26px',
  borderRadius: '50%',
  cursor: 'pointer',
  color: DEEP_MOSS,
  fontSize: '0.9rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const descriptionStyle = {
  fontFamily: "'Montserrat', sans-serif",
  fontSize: '0.78rem',
  lineHeight: '1.6',
  color: DEEP_MOSS,
  opacity: 0.8,
  margin: 0,
};

const headphonesNote = {
  fontFamily: "'Montserrat', sans-serif",
  fontSize: '0.65rem',
  color: '#aaa',
  fontStyle: 'italic',
  margin: 0,
  letterSpacing: '0.5px',
};

export default Atmosphere;